// extracted by mini-css-extract-plugin
export var exit = "_5-3";
export var notificationContainer = "_5-1";
export var notificationStack = "_5-0";
export var shrinkFadeOut = "_5-4";
export var slideInUp = "_5-2";